import { filter } from "rxjs/operators";
export function instanceOf(arg) {
    return typeof arg === "function"
        ? filter((value) => value instanceof arg)
        : filter((value) => Object.keys(arg).some((key) => value instanceof arg[key]));
}
//# sourceMappingURL=instanceOf.js.map